import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueI18n from 'vue-i18n';
import ru from './localization/ru';
import en from './localization/en';
import Maska from 'maska';
import VeeValidate, { Validator } from 'vee-validate';
import VueClickOutside from 'vue-click-outside';
import './registerServiceWorker';

import BaseTextInput from './components/base/BaseTextInput.vue';
// import BaseToast from './components/base/BaseToast.vue';

import BaseButton from './components/base/BaseButton.vue';

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

Vue.config.productionTip = false;
window.kapystaRouter = router;

Validator.extend('supportMessage', {
  getMessage: 'Максимальное количество символов: 300',
  validate: value => {
    return value.length >= 1 && value.length <=300;
  }
});

Validator.extend('offerCount', {
  getMessage: 'Не более 20 займов',
  validate: value => {
    return +value > 0 && +value <= 20;
  }
});

Validator.extend('offerRating', {
  getMessage: 'Поле не верно',
  validate: value => {
    return +value >= 0 && +value <= 100;
  }
});

Validator.extend('offerPercent', {
  getMessage: 'Поле не верно',
  validate: value => {
    const minPercent = window.entityCabinetSettings.offer.minPercent;
    const maxPercent = window.entityCabinetSettings.offer.maxPercent;
    return +value >= minPercent && +value <= maxPercent;
  }
});

Validator.extend('offerTerm', {
  getMessage: 'Поле не верно',
  validate: value => {
    const minTerm = window.entityCabinetSettings.offer.minTerm;
    const maxTerm = window.entityCabinetSettings.offer.maxTerm;
    return +value >= minTerm && +value <= maxTerm;
  }
});

Validator.extend('offerAmount', {
  getMessage: 'Поле не верно',
  validate: value => {
    const minAmount = window.entityCabinetSettings.offer.minAmount;
    const maxAmount = window.entityCabinetSettings.offer.maxAmount;
    return +value >= minAmount && +value <= maxAmount;
  }
});

Validator.extend('totalIncome', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('dependensNumber', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 1
});

Validator.extend('workExperience', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 1
});

Validator.extend('otherPositionType', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('nameOfOrganization', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('livingAddress', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('registrationAdress', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('idIssuedBy', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('idSeries', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('birthPlace', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('codeword', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('citizenship', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('name', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('middleName', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('surname', {
  getMessage: 'Поле не верно',
  validate: value => value.length >= 2
});

Validator.extend('msisdn', {
  getMessage: 'Номер телефона не верен',
  validate: value => {
    const filteredValue = value.replace(/[^\d]/g, '');

    return /(375)\d{9,9}/.test(filteredValue);
  }
});

Validator.extend('password', {
  getMessage: 'Не менее 8 символов, минимум одна прописная и одна строчная буква, одна цифра',
  validate: value => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(value)
});

Validator.extend('login', {
  getMessage: 'Логин не верен',
  validate: value => value.length >= 6
});

Validator.extend('required', {
  getMessage: 'Поле обязательно',
  validate: value => String(value || '').trim().length > 0
});

Validator.extend('requiredEmail', {
  getMessage: 'Поле обязательно',
  validate: value => ({
    required: true,
    valid: String(value || '').trim().length > 0
  }),
  computesRequired: true
});

Validator.extend('passwordConfirmation', {
  getMessage: 'Пароли не совпадают',
  validate: (value, [otherValue]) => {
    return value === otherValue;
  },
  hasTarget: true
});

const formatLoanPayAmount = (amount) => (Number(amount) / 100).toFixed(2);

Validator.extend('loanPayConfirmation', {
  getMessage: (field, [maxAmount], data) => {
    if (data?.reason === 'max') {
      return `Максимальная сумма к оплате ${formatLoanPayAmount(maxAmount)}`;
    }

    return 'Минимальная сумма 10 копеек';
  },
  validate: (value, [maxAmount, minAmount = '10']) => {
    const amountMinor = Number((+value * 100).toFixed(0));
    const max = Number(maxAmount);
    const min = Number(minAmount);

    if (amountMinor < min) {
      return {
        valid: false,
        data: {
          reason: 'min'
        }
      };
    }

    if (amountMinor > max) {
      return {
        valid: false,
        data: {
          reason: 'max'
        }
      };
    }

    return {
      valid: true
    };
  },
  hasTarget: true
});

Validator.extend('otp', {
  getMessage: 'Минимальная длина 4 символа',
  validate: value => value.length >= 6
});

Vue.filter('cardPan', function(value) {
  const parsedPan = value.slice(0, 4) + ' ' + value.slice(4, 8) + 
    ' ' + value.slice(8, 12) + ' ' + value.slice(12, 16);
  return parsedPan.toUpperCase();
});

Vue.filter('cardExpiry', function(value) {
  const parsedExpiry = value.slice(0, 2) + '/' + value.slice(2, 4);
  return parsedExpiry;
});

Vue.filter('offerUserName', function(value) {
  const name = value?.name_ru?.given_name_ru;
  const familyName = value?.name_ru?.family_name_ru;
  const modyfiedFamilyName = familyName.slice(0, 1) + '.';
  return `${name} ${modyfiedFamilyName}`;
});

Vue.component('base-button', BaseButton);
Vue.component('base-text-input', BaseTextInput);

Vue.use(VueAxios, axios);
Vue.use(VueI18n);
Vue.use(Maska);
Vue.use(VeeValidate);
Vue.use(VueClickOutside);
Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
  position: "top-right",
  timeout: 2000,
  closeOnClick: true,
  pauseOnFocusLoss: false,
  pauseOnHover: false,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false
});

// Vue.prototype.$toast = function (methodOptions) {
//   let ComponentClass = Vue.extend(BaseToast);
//   let toastInst = new ComponentClass({
//     propsData: {
//       toastMessage: methodOptions.text,
//       isShown: true,
//       width: methodOptions.width || 310
//     }
//   });
//   toastInst.$mount() // pass nothing
//   setTimeout(() => {
//     document.getElementById('app').appendChild(toastInst.$el);
//     setTimeout(() => {
//       document.getElementById('app').removeChild(toastInst.$el);
//     }, methodOptions.delay || 1500)
//   }, 0);
// }

const locale = 'ru';
const i18n = new VueI18n({
  locale,
  messages: {
    ru,
    en
  }
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
